import { atom } from "jotai";

import { GrowthBookArgs } from "./growthbook.types";

/**
 * Set this when you want growthbook to kick in for feature flags.
 */
export const growthbookConfigAtom = atom<GrowthBookArgs | null>(null);
